import { Flex } from 'foundations-components/components/Flex';
import IndexOrPageReturnLink from './IndexOrPageReturnLink';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import I18n from 'I18n';
import ActionsDropdown from './ActionsDropdown';
import { useCardSettingsActionConfig } from 'crm-cards-sdk/hooks/useCardSettingsActionConfig';
import HubSpotAppLink from 'crm-links/common/components/HubSpotAppLink';
import { SettingsIcon } from 'foundations-assets/icons/components/SettingsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LinkComponent = props => {
  return /*#__PURE__*/_jsx(IconButton, Object.assign({
    size: "sm",
    use: "transparent",
    "aria-label": I18n.text('ObjectHighlightCard.settingsButtonLabel'),
    marginInlineStart: "0"
  }, props));
};
const Heading = () => {
  const adminSettingsConfig = useCardSettingsActionConfig();

  // don't render card heading in the card builder preview
  if (window.location.pathname.includes('card-builder-preview')) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    justifyContent: "space-between",
    alignItems: "center",
    borderBlockEndColor: "border-core-subtle",
    borderBlockEndWidth: "100",
    borderBlockEndStyle: "solid",
    paddingInlineStart: "500",
    paddingInlineEnd: "200",
    blockSize: "40px",
    children: [/*#__PURE__*/_jsx(IndexOrPageReturnLink, {}), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(ActionsDropdown, {}), adminSettingsConfig && adminSettingsConfig.type === 'hubspot-app-link' && /*#__PURE__*/_jsx(HubSpotAppLink, {
        linkType: adminSettingsConfig.linkType,
        linkTypeProps: adminSettingsConfig.linkTypeProps,
        LinkComponent: LinkComponent,
        onTrackClick: adminSettingsConfig.onTrackClick,
        children: /*#__PURE__*/_jsx(SettingsIcon, {})
      })]
    })]
  });
};
export default Heading;